export default __webpack_public_path__ + "locales/zh-CN/EmptyView.json?hash=c442b8a638423aa048bf73eea5dd4928";